<script lang="ts" setup>
// 💡 target="_blank" can be added to the form tag if needed, but then you have 2 tabs open and the user might get confused
import type { NewsletterSubscriptionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ form: NewsletterSubscriptionRecord }>();
</script>

<template>
  <div>
    <!-- BUTTON NOT ALIGNED PERFECTLY WITH ABSOLUTE POSITIONING -->
    <!-- <form :action="form.remoteFormUrl" method="post" class="flex relative h-12">
      <input
        id="MERGE0" name="MERGE0" required
        type="email" autocomplete="email" inputmode="email" spellcheck="false"
        class="grow ps-4 pe-28 text-neutral-800 rounded-full"
        data-1p-ignore
        :placeholder="form.inputPlaceholder"
      >
      <div class="absolute right-1 top-1">
        <UButton variant="solid" color="primary" type="submit">
          {{ form.buttonLabel }}
        </UButton>
      </div>
    </form> -->

    <form id="form-newsletter-subscription--desktop" :action="form.remoteFormUrl" method="post" class="hidden rounded-full bg-white p-1 md:flex">
      <input
        id="MERGE0" name="MERGE0" required
        type="email" autocomplete="email" inputmode="email" spellcheck="false"
        class="me-2 ms-3 grow text-neutral-800 placeholder:text-[#00103599] focus:outline-none"
        data-1p-ignore
        :placeholder="form.inputPlaceholder"
      >
      <div class="flex-none">
        <UButton type="submit" variant="solid" color="primary" size="md">
          {{ form.buttonLabel }}
        </UButton>
      </div>
    </form>

    <form id="form-newsletter-subscription--mobile" :action="form.remoteFormUrl" method="post" class="block md:hidden">
      <UInput
        id="MERGE0" name="MERGE0" required data-1p-ignore
        type="email" autocomplete="email" inputmode="email" spellcheck="false"
        size="xl" :ui="{ base: 'text-neutral-800 placeholder:text-[#00103599] mb-md' }"
        :placeholder="form.inputPlaceholder"
      />
      <UButton type="submit" variant="solid" color="primary" size="xl" :ui="{ base: 'leading-7' }" block>
        {{ form.buttonLabel }}
      </UButton>
    </form>
  </div>
</template>

<style scoped>
#form-newsletter-subscription--desktop:has(input:focus) {
  outline: 2px solid var(--color-non-500);
  outline-offset: 2px;
}
</style>
